import React from 'react';

import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

import SaveButton from './SaveButton';


const WitnessesTab = (props) => {
    const {
        couple,
        setCouple,
        handleChange,
        state
    } = props;

    const [formErrors, setFormErrors] = React.useState({});

    return (
        <form>
            <Grid container spacing={3}>
                <Grid item xs={6}>
                    <Box>
                        <Typography variant="overline" color="primary" display="block">
                            Witness 1
                        </Typography>
                    </Box>
                    <TextField
                        fullWidth
                        margin="normal"
                        onChange={handleChange('witness1_first_name')}
                        label="First Name"
                        value={state.witness1_first_name || ''}
                    />
                    <TextField
                        fullWidth
                        margin="normal"
                        onChange={handleChange('witness1_last_name')}
                        label="Last Name"
                        value={state.witness1_last_name || ''}
                    />
                    <TextField
                        fullWidth
                        margin="normal"
                        onChange={handleChange('witness1_address')}
                        label="Address"
                        value={state.witness1_address || ''}
                    />
                    <TextField
                        fullWidth
                        margin="normal"
                        onChange={handleChange('witness1_city')}
                        label="City"
                        value={state.witness1_city || ''}
                    />
                    <TextField
                        select
                        fullWidth
                        margin="normal"
                        onChange={handleChange('witness1_province')}
                        label="Province"
                        value={state.witness1_province || ''}
                        SelectProps={{
                            autoWidth: true
                        }}
                    >
                        {provinces.map(option => (
                            <MenuItem key={option.id} value={option.id}>
                                {option.province_name}
                            </MenuItem>
                        ))}
                    </TextField>
                    <TextField
                        fullWidth
                        margin="normal"
                        onChange={handleChange('witness1_postal_code')}
                        label="Postal Code"
                        value={state.witness1_postal_code || ''}
                    />
                </Grid>
                <Grid item xs={6}>
                    <Box>
                        <Typography variant="overline" color="primary" display="block">
                            Witness 2
                        </Typography>
                    </Box>
                    <TextField
                        fullWidth
                        margin="normal"
                        onChange={handleChange('witness2_first_name')}
                        label="First Name"
                        value={state.witness2_first_name || ''}
                    />
                    <TextField
                        fullWidth
                        margin="normal"
                        onChange={handleChange('witness2_last_name')}
                        label="Last Name"
                        value={state.witness2_last_name || ''}
                    />
                    <TextField
                        fullWidth
                        margin="normal"
                        onChange={handleChange('witness2_address')}
                        label="Address"
                        value={state.witness2_address || ''}
                    />
                    <TextField
                        fullWidth
                        margin="normal"
                        onChange={handleChange('witness2_city')}
                        label="City"
                        value={state.witness2_city || ''}
                    />
                    <TextField
                        select
                        fullWidth
                        margin="normal"
                        onChange={handleChange('witness2_province')}
                        label="Province"
                        value={state.witness2_province || ''}
                        SelectProps={{
                            autoWidth: true
                        }}
                    >
                        {provinces.map(option => (
                            <MenuItem key={option.id} value={option.id}>
                                {option.province_name}
                            </MenuItem>
                        ))}
                    </TextField>
                    <TextField
                        fullWidth
                        margin="normal"
                        onChange={handleChange('witness2_postal_code')}
                        label="Postal Code"
                        value={state.witness2_postal_code || ''}
                    />
                </Grid>
            </Grid>
            <Box mt={4} mb={3}>
                <Grid
                    container
                    direction="row"
                    justify="center"
                    alignItems="center"
                >
                    <Grid item xs={12} sm={4}>
                        <SaveButton
                            state={state}
                            coupleId={couple.id}
                            setCouple={setCouple}
                            setFormErrors={setFormErrors}
                        />
                    </Grid>
                </Grid>
            </Box>
        </form>
    )
};

export default WitnessesTab;
